var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.close,
          expression: "close",
        },
      ],
      staticClass: "c-select c-multi-select",
      on: { click: _vm.toggle },
    },
    [
      _c("div", { staticClass: "multi-select__placeholder" }, [
        _vm._v(_vm._s(_vm.placeholder)),
      ]),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "multi-select-list",
          class: { "multi-select-list--open": _vm.visible },
        },
        _vm._l(_vm.filteredItems, function (item, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "multi-select-list__item",
              attrs: { value: item.name },
              on: {
                click: function ($event) {
                  return _vm.select(item.name)
                },
              },
            },
            [_vm._v("\n            " + _vm._s(item.name) + "\n        ")]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }